import React from "react";
import BannerOverlay from "../BannerOverlay/BannerOverlay";
import ImageComponent from "@project-stories/elements/Image/Image";
import { sendGtagEvent } from "frontend/js/helpers";

const BannerImage = ({ blockItem, section_settings, isMobile, isLazy, isHero = false, isFirstSlide = false }) => {
  let imageUrl = blockItem.settings.image?.src ?? blockItem.settings.image;

  let imageHeight = blockItem.image_height;
  let imageWidth = blockItem.image_width;

  if (isMobile) {
    imageUrl = blockItem.settings.mobile_image
      ? blockItem.settings.mobile_image
      : blockItem.settings.image?.src ?? blockItem.settings.image;

      imageHeight = blockItem.mobile_image_height;
      imageWidth = blockItem.mobile_image_width;

  }
  const imageUrlDefined = blockItem.settings.button_url?.length > 0; // Check if a URL is defined
  
  // Determine if this image should be prioritized (hero banner first slide)
  const shouldPrioritize = isHero || isFirstSlide;
  const actuallyLazy = shouldPrioritize ? false : isLazy;

  // Get focal points and background size settings
  const focalPointX = blockItem.image_focal_points && blockItem.image_focal_points.x
    ? `${blockItem.image_focal_points.x}%`
    : "center";

  const focalPointY = blockItem.image_focal_points && blockItem.image_focal_points.y
    ? `${blockItem.image_focal_points.y}%`
    : "center";

  const backgroundSize = blockItem.settings.background_size || "cover";
  
  // Determine object position for image
  const objectPosition = `${focalPointX} ${focalPointY}`;
  
  const ImageContent = ({isLazy = true}) => (
    <div className="absolute top-0 left-0 w-full h-full">
      <ImageComponent
        imageUrl={imageUrl}
        alt={blockItem.image_alt || blockItem.settings.title || 'Banner image'}
        classes={`object-cover h-full w-full`}
        isLazy={isLazy}
        useSrcSet={true}
        sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 75vw"
        priority={shouldPrioritize}
        height={imageHeight}
        width={imageWidth}
      />
    </div>
  );

  function handleClick (e, blockItem) {
    e.preventDefault();

    console.log('Banner clicked:', blockItem);

    sendGtagEvent(
      'select_promotion',
      blockItem?.id,
      blockItem?.settings?.promotional_name,
      'banner',
      blockItem?.settings?.button_url
    );
  }

  function handleSecondButtonClick(e, blockItem) {
    e.preventDefault();
    sendGtagEvent(
      'select_promotion',
      blockItem?.id,
      blockItem?.settings?.promotional_name,
      'banner_second_button',
      blockItem?.settings?.button_url_2
    );
  }

  return (
    <>
      {blockItem.settings.show_overlay &&
        (imageUrlDefined &&
        (blockItem.settings.button_url === "" ||
          blockItem.settings.button_url === "#") ? (
          <a
            href={blockItem.settings.image_url}
            className="absolute block w-full h-full"
          >
            <BannerOverlay
              blockItem={blockItem}
              section_settings={section_settings}
              isMobile={isMobile}
              onClick={(e) => handleClick(e, blockItem)}
              onSecondButtonClick={(e) => handleSecondButtonClick(e, blockItem)}
            />
          </a>
        ) : (
          <BannerOverlay
            blockItem={blockItem}
            section_settings={section_settings}
            isMobile={isMobile}
            onClick={(e) => handleClick(e, blockItem)}
            onSecondButtonClick={(e) => handleSecondButtonClick(e, blockItem)}
          />
        ))}
      <div
        className={`banner-image ${blockItem.settings.darken_image && "content-over-media"} w-screen h-screen`}
      >
        {imageUrlDefined &&
        (blockItem.settings.button_url === "" ||
          blockItem.settings.button_url === "#") ? (
          <a
            href={blockItem.settings.image_url}
            className="block w-full h-full"
          >
            <ImageContent isLazy={isLazy}/>
          </a>
        ) : (
          <ImageContent isLazy={isLazy}/>
        )}
      </div>
    </>
  );
};

export default BannerImage;
